import React from "react";
import Nav from "../../components/nav";
import Footer from "../../components/footer";
import Aboutph from "../../assets/pic/about.png";
import {Helmet} from "react-helmet";

const AboutUs = ()=>{
    return(
        <div className='about-wrap'>
            <Helmet>
                <title>
                    درباره ی بل میت
                </title>
                <meta name="description" content="درباره ی تیم جوان و دانش محور بل میت بیشتر بدانیم" />
            </Helmet>
            <Nav />
                <div className='about-dec'>
                    <h1>درباره ی ما</h1>
                    <img src={Aboutph} alt="تیم بل میت"/>
                    <p>در عرصه علم و تکنولوژی یکی از مهم‌ترین دستاوردهای جهان از بین بردن محدودیت‌های  ارتباطی است که به همین جهت بعد از گذشت سال‌ها تحقیق و تجربه در این حوزه، توانستیم ساده‌ترین مدل ارتباطی را شکل دهیم. </p>
                    <p>در این مسیر با توجه با اتفاقاتی که در جهان رخ داد، ناخواسته سرعت احساس نیاز به جلسات غیر حضوری افزایش قابل ملاحظه‌ای پیدا کرد که به دنبال آن رقابت در این حوزه نیز جذاب‌تر گردید. در همین خصوص ما تمام توان و تلاش خود را صرف ارائه پایدارترین، با جزئیات‌ترین و بروزترین سیستم مدل ارتباطی (جلسات مجازی) برای تمامی مردمان جهان ایجاد کردیم. با توجه به تمامی محدودیت‌‌های داخل کشور عزیزمان ایران، با افتخار توانستیم ابزاری مناسب جهت ارتباطات غیر حضوری هم‌وطنان عزیزمان فراهم کنیم.</p>
                    <p>ما شبانه‌روز در حال تحقیق و توسعه هستیم و بر اساس نیاز روز جهان رشد می‌کنیم. بزرگ‌ترین عامل رشد چشم‌گیرمان در حوزه ارتباطات و برگزاری جلسات مجازی را مدیون پشتیبانی ویژه تیم فنی هستیم که رضایت‌مندی بالایی را در ذهن کاربران به وجود آورده‌اند. ما همگی بر این باوریم که بزرگترین سرمایه ما لبخند رضایت کاربران است.</p>
                    <p>در نهایت از اعتماد شما نهایت سپاس‌گزاری را داریم و هر روز با شما عزیزان، مسیر موفقیتمان را در میان خواهیم گذاشت.</p>
                </div>
            <Footer />
        </div>
    )
}

export default AboutUs